import React from 'react';

const ProjectOne = () => {
    return (
      <div className="my-4">
        <h1 className="text-5xl text-black  my-4">Screen Shots</h1>

        <div className="carousel w-full">
          <div id="item1" className="carousel-item w-full">
            <img
              
              src="https://i.ibb.co/4FmRrWh/p1-1.png"
              className="mx-auto w-fit"
            />
          </div>
          <div id="item2" className="carousel-item w-full">
            <img
              style={{ width: "800px", height: "782px" }}
              src="https://i.ibb.co/kc8TTbw/p1-2.png"
              className="mx-auto"
            />
          </div>
          <div id="item3" className="carousel-item w-full">
            <img
              style={{ width: "800px", height: "782px" }}
              src="https://i.ibb.co/0GVtfXk/p1-3.png"
              className="mx-auto"
            />
          </div>
          <div id="item4" className="carousel-item w-full">
            <img
              style={{ width: "800px", height: "782px" }}
              src="https://i.ibb.co/LtMJHdx/p1-4.png"
              className="mx-auto"
            />
          </div>
        </div>
        <div className="flex justify-center w-full py-2 gap-2">
          <a href="#item1" className="btn btn-xs">
            1
          </a>
          <a href="#item2" className="btn btn-xs">
            2
          </a>
          <a href="#item3" className="btn btn-xs">
            3
          </a>
          <a href="#item4" className="btn btn-xs">
            4
          </a>
        </div>
        <div>
          <p className="text-black">
            Descriptions: • Created a fully functional, clean and user-friendly
            interface. Implemented responsive design for desktop, mobile and
            tablet. • Showcased products on the homepage and restricted ordering
            and payment for logged-in users only. Stored user information on
            database like reviews and credentials. • Added admin panel and
            established authorities like adding a product, making an admin,
            cancel an unpaid order or approve a paid order for shipping and
            update database.
          </p>
        </div>
        <div className="flex flex-wrap justify-center my-10">
          <a
            className="btn btn-outline mr-4"
            href="https://power-tools-b56dd.web.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Live Site{" "}
          </a>
          <a
            className="btn btn-outline mr-4"
            href="https://github.com/sasohan0/Power-Tools"
            target="_blank"
            rel="noopener noreferrer"
          >
            Front-End Code
          </a>
          <a
            className="btn btn-outline"
            href="https://github.com/sasohan0/Power-Tools-Server"
            target="_blank"
            rel="noopener noreferrer"
          >
            Backend Code
          </a>
        </div>
      </div>
    );
};

export default ProjectOne;